export const ACCEPTANCE_DOCUMENT_FILE_TYPE = 'CLIENT_CONFIRMATION';

export const ACCEPTANCE_ARTIFACT_MODAL_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
} as const;

export type AcceptanceArtifactModalMode =
  (typeof ACCEPTANCE_ARTIFACT_MODAL_MODE)[keyof typeof ACCEPTANCE_ARTIFACT_MODAL_MODE];

export const ACCEPTANCE_POLICY_LINK =
  'https://git.syberry.com/syberry-policies/delivery/-/tree/main/acceptance?ref_type=heads';
